import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .max(30, "Name must not exceed 30 characters")
    .matches(
      /^[a-zA-Z\s-]+$/,
      "Name can only contain letters, spaces, and hyphens"
    )
    .required("Name is required"),
  email: Yup.string()
    .email("Please enter a valid email address")
    .max(50, "Email must not exceed 50 characters")
    .required("Email is required"),
  // role_id: Yup.number()
  //     .required('User role is required'),
  group_permissions_id: Yup.number().required("Permission group is required"),
});

export const permissionValidationSchema = Yup.object().shape({
  name: Yup.string()
    .max(30, "Permission Name must not exceed 30 characters")
    .required("Permission Name is required"),
  description: Yup.string()
    .max(255, "Description must not exceed 255 characters")
    .required("description is required"),
});

export const editUserValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .max(30, "Name must not exceed 30 characters")
    .matches(
      /^[a-zA-Z\s-]+$/,
      "Name can only contain letters, spaces, and hyphens"
    )
    .required("Name is required"),
  group_permissions_id: Yup.number().required("Permission group is required"),
});

export const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email address")
    .max(50, "Email must not exceed 50 characters")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

export const forgotSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email address")
    .max(50, "Email must not exceed 50 characters")
    .required("Email is required"),
});

export const resetSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      "Password must contain at least one uppercase letter, one lowercase letter, and one number"
    )
    .required("Password is required"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
});

export const registerSchema = Yup.object().shape({
  username: Yup.string()
    .min(2, "Username must be at least 2 characters")
    .max(30, "Username must not exceed 30 characters")
    .matches(
      /^[a-zA-Z\s-]+$/,
      "Username can only contain letters, spaces, and hyphens"
    )
    .required("Username is required"),
  email: Yup.string()
    .email("Please enter a valid email address")
    .max(50, "Email must not exceed 50 characters")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      "Password must contain at least one uppercase letter, one lowercase letter, and one number"
    )
    .required("Password is required"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
});

export const addIssueValidationSchema = Yup.object().shape({
  // vehicle_id: Yup.number()
  //     .required('Vehicle is required'),
  // service_id: Yup.number()
  //     .required('Service ID is required'),
  reported_by: Yup.number().required("Reported by is required"),
  assign_to: Yup.number().required("Assigned to is required"),
  odo_meter: Yup.number()
    .min(0, "Odometer reading must be zero or positive")
    .required("Odometer reading is required"),
  priority: Yup.string()
    .oneOf(["low", "medium", "high"], "Priority must be low, medium, or high")
    .required("Priority is required"),
  summery: Yup.string()
    .max(255, "Summary must not exceed 255 characters")
    .required("Summary is required"),
  description: Yup.string().max(
    1000,
    "Description must not exceed 1000 characters"
  ),
  reported_at: Yup.date().required("Reported date is required"),
  tags: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string(),
        label: Yup.string(),
      })
    )
    .nullable(),
});

export const IssueValidationSchema = Yup.object().shape({
  vehicle_id: Yup.number().required("Vehicle is required"),
  reported_by: Yup.number().required("Reported by is required"),
  assign_to: Yup.number().required("Assigned to is required"),
  odm: Yup.number()
    .min(0, "Odometer reading must be zero or positive")
    .required("Odometer reading is required")
    .test(
      "min-last-recorded",
      "Odometer reading cannot be less than last recorded value",
      function (value) {
        const { odo_meter } = this.options.context || {};

        if(!odo_meter) return true

        const lastOdo = parseInt(odo_meter);
        if (typeof value !== "number") return true;
        return value >= parseInt(lastOdo);
      }
    ),
  priority: Yup.string()
    .oneOf(["low", "medium", "high"], "Priority must be low, medium, or high")
    .required("Priority is required"),
  summery: Yup.string()
    .max(255, "Summary must not exceed 255 characters")
    .required("Summary is required"),
  description: Yup.string().max(
    1000,
    "Description must not exceed 1000 characters"
  ),
  reported_at: Yup.date().required("Reported date is required"),
  tags: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string(),
        label: Yup.string(),
      })
    )
    .nullable(),
});

export const WorkOrderValidationSchema = Yup.object().shape({
  asset_id: Yup.string().required("Vehicle is required"),
  repair_class: Yup.string().required("Repair class is required"),
  issued_at: Yup.date().required("Issued At is required"),
  scheduled_start_at: Yup.date()
    .nullable()
    .required("Scheduled Start Date is required"),
  expected_completion_at: Yup.date()
    .nullable()
    .required("Expected Completion Date is required"),
  issued_by: Yup.string().required("Issued By is required"),
  assigned_to: Yup.string().required("Assignee is required"),
  vendor_id: Yup.string().required("Vendor is required"),
  invoice_no: Yup.string().required("Invoice Number is required"),
  service_ids: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string(),
        label: Yup.string(),
      })
    )
    .nullable(),
  tags: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string(),
        label: Yup.string(),
      })
    )
    .nullable(),
});

export const serviceEntryValidationSchema = Yup.object().shape({
  vehicle_id: Yup.number().required("Vehicle is required"),
  odm: Yup.number()
    .min(0, "Odometer reading must be zero or positive")
    .required("Odometer reading is required")
    .test(
      "min-last-recorded",
      "Odometer reading cannot be less than last recorded value",
      function (value) {
        const { odo_meter } = this.options.context || {};

        if(!odo_meter) return true

        const lastOdo = parseInt(odo_meter);
        if (typeof value !== "number") return true;
        return value >= parseInt(lastOdo);
      }
    ),
  priority: Yup.string()
    .oneOf(["low", "medium", "high"], "Priority must be low, medium, or high")
    .required("Priority is required"),
  services_type: Yup.string()
    .oneOf(
      ["scheduled", "unscheduled"],
      "Service type must be scheduled or unscheduled"
    )
    .required("Service type is required"),
  start_at: Yup.date(),
  complete_at: Yup.date().required("Completion date is required"),
  note: Yup.string().max(1000, "Notes must not exceed 1000 characters"),
  tags: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string(),
        label: Yup.string(),
      })
    )
    .nullable(),
});

export const serviceLineSchema = Yup.object().shape({
  cost_parts: Yup.number()
    .min(0, "Parts cost must be zero or positive")
    .required("Parts cost is required"),
  rate: Yup.number()
    .min(0, "Unit Price must be zero or positive")
    .required("Unit Price is required"),
  qty: Yup.number()
    .min(0, "Quantity must be zero or positive")
    .required("Quantity is required"),
  cost_labor: Yup.number()
    .min(0, "Labor must be zero or positive")
    .required("Labor is required"),
  sub_total: Yup.number()
    .min(0, "Subtotal must be zero or positive")
    .required("Subtotal is required"),
  service_category_id: Yup.number().required("Category is required"),
  repair_reason_id: Yup.number().required("Reason for repair is required"),
  odo_meter: Yup.number()
    .min(0, "Odometer reading must be zero or positive")
    .required("Odometer reading is required"),
  description: Yup.string().max(
    500,
    "Description must not exceed 500 characters"
  ),
});
